/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Stitch Web
 * OpenAPI spec version: 0.0.53
 */

export type CreatePatientSex =
	(typeof CreatePatientSex)[keyof typeof CreatePatientSex];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreatePatientSex = {
	Male: 'Male',
	Female: 'Female',
	Other: 'Other',
	Unknown: 'Unknown',
} as const;
